import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBDXnw0CgRO47W_J6pARuhodlnKxPfndW8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "jpegs-dev.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "jpegs-dev",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "jpegs-dev.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1077591545658",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1077591545658:web:54c3c988d2718de916a203"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

export default app;
